// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.as-searchForm-wrapper {
  --as-searchForm-bg-color: #f7f9fd;
}
.as-dataTable {
  height: 100%;
  -webkit-flex: 1 1 auto;
          flex: 1 1 auto;
}
.as-dataTable-card-fill {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
          flex-direction: column;
}
.as-dataTable-operation-column .wui-table-title-icon-list-3 {
  display: none!important;
}
.as-dataTable-operation-custom {
  -webkit-flex: 1 1;
          flex: 1 1;
}
.as-dataTable-operation-btn.wui-button.wui-button-light {
  border: 1px solid #D9D9D9;
  color: #9CA3AF;
}
.as-dataTable-operation-btn.wui-button.wui-button-light:hover {
  border: 1.22px solid #4B5563;
  color: #4B5563;
  background-color: #fff;
}
.as-dataTable-toolbar {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
          align-items: center;
  -webkit-justify-content: space-between;
          justify-content: space-between;
  padding: 0 16px;
}
.as-dataTable .as-cardTable-empty-context {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
          align-items: center;
  -webkit-justify-content: center;
          justify-content: center;
}
.as-dataTable .as-cardTable-container {
  height: 100%;
  overflow: hidden;
  position: relative;
}
.as-dataTable .as-cardTable-container-nospace {
  overflow: initial!important;
}
.as-dataTable .as-cardTable-content {
  height: auto;
  overflow-x: hidden;
}
.as-dataTable .as-cardTable-content-page-fixed {
  height: calc(100% - 62px);
  overflow-y: auto;
}
.as-dataTable .as-cardTable-content-page-fixed:hover::-webkit-scrollbar {
  width: var(--ynfw-size-width-scroll-scrollbar, 8px);
  height: var(--ynfw-size-width-scroll-scrollbar, 8px);
}
.as-dataTable .as-cardTable-content-page-fixed::-webkit-scrollbar {
  width: var(--ynfw-size-width-scroll-scrollbar, 8px);
  height: var(--ynfw-size-width-scroll-scrollbar, 8px);
}
.as-dataTable .as-cardTable-content-page-fixed:hover::-webkit-scrollbar-track-piece,
.as-dataTable .as-cardTable-content-page-fixed:hover::-webkit-scrollbar-track {
  background-color: var(--ynfw-color-bg-scrollbg-scrollbar, #f4f4f4);
  border-color: var(--ynfw-color-border-scrollbar, #dedede);
}
.as-dataTable .as-cardTable-content-page-fixed:hover::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: var(--ynfw-color-bg-scroll-scrollbar, #99a3b0);
}
.as-dataTable .as-cardTable-content-page-fixed:hover::-webkit-scrollbar-thumb:hover {
  background-color: var(--ynfw-color-bg-scroll-scrollbar-hover, #687281);
}
.as-dataTable .as-cardTable-content-page-fixed::-webkit-scrollbar-button,
.as-dataTable .as-cardTable-content-page-fixed::-webkit-scrollbar-corner {
  display: none;
}
@-moz-document url-prefix() {
  .as-dataTable .as-cardTable-content-page-fixed {
    scrollbar-color: var(--ynfw-color-bg-scroll-scrollbar, #99a3b0) var(--ynfw-color-bg-scrollbg-scrollbar, #f4f4f4);
    scrollbar-width: none;
  }
  .as-dataTable .as-cardTable-content-page-fixed:hover {
    scrollbar-width: thin;
  }
}
.as-dataTable .as-cardTable-content-page-nofill {
  height: auto!important;
  overflow-y: inherit!important;
}
.as-dataTable .as-cardTable-content-page-fill {
  height: 100%!important;
  overflow-y: auto!important;
}
.as-dataTable .as-cardTable-pagination {
  margin: 16px 0;
}
.as-dataTable .as-cardTable-pagination .wui-pagination {
  margin-right: 0!important;
}
.as-dataTable .as-cardTable-pagination-fixed {
  position: absolute;
  right: 0px;
  bottom: 0px;
  left: 0;
}
`, "",{"version":3,"sources":["webpack://./src/assets/style/public.less","webpack://./src/assets/style/as-variable.less","webpack://./src/components/DataTable/src/Table.less"],"names":[],"mappings":"AAAC;ECIC,iCAAA;ACFF;AFFC;EEEC,YAAA;EACA,sBAAA;UAAA,cAAA;AAGF;AAFE;EACE,qBAAA;EAAA,aAAA;EACA,8BAAA;UAAA,sBAAA;AAIJ;AAFE;EACE,uBAAA;AAIJ;AAFE;EACE,iBAAA;UAAA,SAAA;AAIJ;AAFE;EACE,yBAAA;EACA,cAAA;AAIJ;AAHI;EACE,4BAAA;EACA,cAAA;EACA,sBAAA;AAKN;AAFE;EACE,qBAAA;EAAA,aAAA;EACA,2BAAA;UAAA,mBAAA;EACA,sCAAA;UAAA,8BAAA;EACA,eAAA;AAIJ;AACI;EACE,qBAAA;EAAA,aAAA;EACA,2BAAA;UAAA,mBAAA;EACA,+BAAA;UAAA,uBAAA;AACN;AACI;EACI,YAAA;EACA,gBAAA;EACA,kBAAA;AACR;AACI;EACE,2BAAA;AACN;AACI;EACE,YAAA;EACA,kBAAA;AACN;AAEI;EACE,yBAAA;EACA,gBAAA;AAAN;AFzCE;EACE,mDAAA;EACA,oDAAA;AE2CJ;AFxCE;EACE,mDAAA;EACA,oDAAA;AE0CJ;AFvCE;;EAEE,kEAAA;EACA,yDAAA;AEyCJ;AFtCE;EACE,kBAAA;EACA,gEAAA;AEwCJ;AFtCI;EACE,sEAAA;AEwCN;AFpCE;;EAEE,aAAA;AEsCJ;AFlCE;EAAA;IACE,gHAAA;IACA,qBAAA;EEqCF;EFnCE;IACE,qBAAA;EEqCJ;AACF;AA9BK;EACC,sBAAA;EACA,6BAAA;AAgCN;AA9BK;EACC,sBAAA;EACA,0BAAA;AAgCN;AA7BI;EACI,cAAA;AA+BR;AAhCI;EAGM,yBAAA;AAgCV;AA7BI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,OAAA;AA+BN","sourcesContent":["// 定义变量\n@-scrollbar-width: var(--ynfw-size-width-scroll-scrollbar, 8px);\n@-scrollbar-color: var(--ynfw-color-bg-scroll-scrollbar, #99a3b0);\n@-scrollbar-bg-color: var(--ynfw-color-bg-scrollbg-scrollbar, #f4f4f4);\n@-scrollbar-border-color: var(--ynfw-color-border-scrollbar, #dedede);\n@-scrollbar-hover-color: var(--ynfw-color-bg-scroll-scrollbar-hover, #687281);\n\n// 设置滚动条样式 mixin\n.set-scrollbar-style(@width: @-scrollbar-width, @initWidth: @-scrollbar-width) {\n\n  // chrome\n  &:hover::-webkit-scrollbar {\n    width: @width; // 纵向滚动条宽度\n    height: @width; // 横向滚动条高度\n  }\n\n  &::-webkit-scrollbar {\n    width: @initWidth; \n    height: @initWidth; \n  }\n\n  &:hover::-webkit-scrollbar-track-piece,\n  &:hover::-webkit-scrollbar-track {\n    background-color: @-scrollbar-bg-color;\n    border-color: @-scrollbar-border-color;\n  }\n\n  &:hover::-webkit-scrollbar-thumb {\n    border-radius: 4px;\n    background-color: @-scrollbar-color;\n\n    &:hover {\n      background-color: @-scrollbar-hover-color;\n    }\n  }\n\n  &::-webkit-scrollbar-button,\n  &::-webkit-scrollbar-corner {\n    display: none;\n  }\n\n  // firefox\n  @-moz-document url-prefix() {\n    scrollbar-color: @-scrollbar-color @-scrollbar-bg-color;\n    scrollbar-width: none;\n\n    &:hover {\n      scrollbar-width: thin;\n    }\n  }\n}","@import \"./prefix.less\";\n@import \"./public.less\";\n\n.@{as-searchForm}-wrapper {\n  --@{as-searchForm}-bg-color: #f7f9fd;\n}\n\n","@import \"../../../assets/style/as-variable.less\";\n.@{as-dataTable}{ \n  height: 100%;\n  flex: 1 1 auto;\n  &-card-fill {\n    display: flex;\n    flex-direction: column;\n  }\n  &-operation-column .wui-table-title-icon-list-3{\n    display: none!important;\n  }\n  &-operation-custom{\n    flex:1;\n  }\n  &-operation-btn.wui-button.wui-button-light{\n    border: 1px solid #D9D9D9;\n    color: #9CA3AF;\n    &:hover{\n      border: 1.22px solid #4B5563;\n      color: #4B5563;\n      background-color: #fff;\n    }\n  }\n  &-toolbar{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 16px;\n  }\n\n\n.@{as-cardTable}{\n    &-empty-context{\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n    &-container{\n        height: 100%;\n        overflow: hidden;\n        position: relative;\n    }\n    &-container-nospace{\n      overflow: initial!important;\n    }\n    &-content{\n      height: auto;\n      overflow-x: hidden;\n    }\n\n    &-content-page-fixed{\n      height: calc(100% - 62px);\n      overflow-y: auto;\n      .set-scrollbar-style()\n    }\n     &-content-page-nofill{\n      height: auto!important;\n      overflow-y: inherit!important;\n    }\n     &-content-page-fill{\n      height: 100%!important;\n      overflow-y: auto!important;\n    }\n   \n    &-pagination{\n        margin: 16px 0;\n        .wui-pagination{\n          margin-right:0!important;\n        }\n    }\n    &-pagination-fixed{\n      position: absolute;\n      right: 0px;\n      bottom: 0px;\n      left: 0;\n\n    }\n\n}\n}\n\n\n// .card-table-container{\n//     height: 100%;\n//     overflow: auto;\n// }\n// .card-table-container-page-fixed{\n//     padding-bottom: 50px;\n// }\n\n// .card-table-pagination{\n//     padding:10px 0px;\n// }\n// .card-table-pagination-fixed{\n//     position: fixed;\n//     right: 0px;\n//     bottom: 0px;\n// }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
